import { render, staticRenderFns } from "./MaterialRow.vue?vue&type=template&id=1a477faa&scoped=true&lang=pug&"
import script from "./MaterialRow.vue?vue&type=script&lang=js&"
export * from "./MaterialRow.vue?vue&type=script&lang=js&"
import style0 from "./MaterialRow.vue?vue&type=style&index=0&id=1a477faa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a477faa",
  null
  
)

export default component.exports